import type { Observable } from 'rxjs';
import type { AssistantsPage } from './assistants.page';

/**
 * CanDeactivate guard for the /chats/assistants route. Prompts on navigate-away
 * while the skill builder modal holds unsaved work (SB-3325 PR-4, Stage B).
 *
 * Angular passes `null` as the component when the instance is not available at
 * guard-run time (destroyed / never fully activated during a racing
 * re-navigation) — nothing to deactivate, so allow navigation.
 * (Fixes SQUADBOX-CR: "Cannot read properties of null (reading 'canDeactivate')")
 */
export const assistantsCanDeactivateGuard = (
  component: AssistantsPage | null,
): Observable<boolean> | boolean =>
  component ? component.canDeactivate() : true;
